module.exports = __webpack_public_path__ + "static/media/image2.65d43dca.jpg";